import { axiosInstance } from "@/axios/interceptors";
import { ZodSentryReporter } from "@/lib/zod-sentry-reporter";
import { z } from "zod";

export const LoggingEvents = z.object({
	page_landed: z.literal("page_landed"),
	document_opened: z.literal("document_opened"),
	document_signed: z.literal("document_signed"),
	page_exited: z.literal("page_exited"),
});

/** Parsed response from getDocumentSigningEventTypes – use this type when passing data into your app. */
export type LoggingEvents = z.infer<typeof LoggingEvents>;

export type LoggingEvent = LoggingEvents[keyof LoggingEvents];

export async function getDocumentSigningEventTypes(locationId: number) {
	const response = await axiosInstance.get(
		`locations/${locationId}/guest-document-signature/event-types`,
	);
	return ZodSentryReporter.parse(LoggingEvents, response);
}

export async function logDocumentSigningEvent(
	locationId: number,
	eventType: LoggingEvent,
) {
	const response = await axiosInstance.post(
		`locations/${locationId}/guest-document-signature/event`,
		{ event_type: eventType },
	);
	return response.data;
}
